import {TaskTag} from "../../../api/Tasks2";
import {
    Checkbox,
    Chip,
    IconButton,
    ListItemButton,
    useTheme
} from "@mui/material";
import {api} from "../../../api/API";
import {css} from "@emotion/css";
import {useRef, useState} from "react";
import {ManageTagsDialog} from "./ManageTagsDialog";
import {useAsync2, useAsyncAction} from "nate-react-api-helpers";
import Settings from "@mui/icons-material/Settings";
import {ArrowDropDown} from "@mui/icons-material";
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import {None} from "./None";
import {TaskPopover} from "./TaskPopover";

export function TaskTags(props: {
    value: TaskTag[];
    onChange(value: TaskTag[]): Promise<any>;
}) {
    const [showManageTags, setShowManageTags] = useState(false);
    const onChange = props.onChange;
    const update = useAsyncAction(onChange, [onChange]);
    const [showTagEdit, setShowTagEdit] = useState(false);
    const theme = useTheme();
    const anchorEl = useRef<HTMLDivElement|null>(null);
    const [refreshKey, setRefreshKey] = useState("-")

    return (
        <>
            <div ref={anchorEl} style={{
                display: "flex",
                flexDirection: "row",
                flexWrap: "wrap",
                gap: 4,
                fontSize: "0.8rem",
            }}>
                {props.value.map(t => <Chip icon={<LocalOfferIcon color="inherit" />} size="small" key={t.id} label={t.tagName}
                      style={{
                          backgroundColor: t.tagColor,
                          color: theme.palette.getContrastText(t.tagColor || "#fff"),
                      }} deleteIcon={<ArrowDropDown />}
                      onClick={() => setShowTagEdit(true)}
                      onDelete={() => setShowTagEdit(true)}
                />)}
                {props.value.length === 0 && <None onClick={() => setShowTagEdit(true)}>
                    No tags
                </None>}
            </div>
            {showTagEdit && <TaskPopover
                 title="Manage Tags" anchorEl={anchorEl.current}
                 onClose={() => setShowTagEdit(false)}
                 extra={<IconButton size="small" onClick={() => setShowManageTags(true)}>
                     <Settings />
                 </IconButton>}
            >
                <ChooseTag
                    key={refreshKey}
                    value={props.value}
                    onChange={props.onChange}
                />
                {update.LoadingElement}
            </TaskPopover>}

            {showManageTags && <ManageTagsDialog onClose={() => {
                setShowManageTags(false)
                setRefreshKey(Date.now().toString());
            }} />}
        </>
    )
}

function ChooseTag(props: {
    value: TaskTag[];
    onChange(value: TaskTag[]): Promise<any>;
}) {
    const [search] = useState("")
    const list = useAsync2((input) => api.tasks2.listTags(input), {
        search: search,
    }, [search]);

    const onChange = props.onChange;
    const update = useAsyncAction(onChange, [onChange]);

    const theme = useTheme();

    return (
        <div style={{
            display: "flex",
            flexDirection: "column",
            gap: 4,
            overflow: "hidden",
        }}>
            {list.LoadingOrErrorElement}
            {update.LoadingElement}
            <div style={{
                overflow: "auto",
                flex: 1,
            }}>
                {list.result?.data.map(r => {
                    const has = props.value.find(v => v.tag === r.id);

                    return (
                        <ListItemButton key={r.id} style={{
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            paddingLeft: 8, paddingRight: 8,
                            paddingTop: 0,
                            paddingBottom: 0,
                        }}
                                        onClick={() => {
                                            if(has) {
                                                update.callback([
                                                    ...props.value.filter(v => v.tag !== r.id),
                                                    Object.assign({}, has, {
                                                        archived: true,
                                                    })
                                                ]);
                                            } else {
                                                update.callback([
                                                    ...props.value,
                                                    {
                                                        id: 0,
                                                        tag: r.id,
                                                        tagName: r.name,
                                                        tagColor: r.color,
                                                        archived: false,
                                                    },
                                                ]);
                                            }
                                        }}>

                            <div style={{
                                flex: 1,

                                display: "flex",
                                alignItems: "center",
                                gap: 4,
                            }}>
                                <Checkbox checked={!!has} size="small"/>
                                <div style={{
                                    backgroundColor: r.color,
                                    color: theme.palette.getContrastText(r.color || "#fff"),
                                    paddingLeft: 6,
                                    paddingRight: 6,
                                    borderRadius: 4,
                                    flex: 1,
                                }}>
                                    {r.name}
                                </div>
                            </div>
                        </ListItemButton>
                    );
                })}
            </div>
        </div>
    )
}

export const sidebarTitleCss = css({
    fontSize: "0.8rem",
})